var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddressLogo = function SvgAddressLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.195,
    height: 26.402,
    viewBox: "1393.5 927 19.195 26.402"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10613",
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1403.094 927c-5.338 0-9.594 4.328-9.594 9.594 0 1.731.433 3.39 1.371 4.833l7.646 11.614c.145.216.361.36.577.36.217 0 .433-.144.578-.36l7.718-11.614c.866-1.443 1.37-3.102 1.298-4.833 0-5.266-4.328-9.594-9.594-9.594m7.07 13.706-7.07 10.676-7.069-10.676a6.921 6.921 0 0 1-1.082-4.112c0-4.472 3.607-8.151 8.151-8.151 4.545 0 8.152 3.679 8.152 8.151 0 1.443-.36 2.885-1.082 4.112",
    "data-name": "Path 280297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.094 932.339c-2.38 0-4.256 1.947-4.256 4.256 0 2.308 1.948 4.256 4.256 4.256 2.308 0 4.256-1.948 4.256-4.256 0-2.309-1.948-4.256-4.256-4.256m0 7.141a2.817 2.817 0 0 1-2.813-2.813c0-1.515 1.298-2.813 2.813-2.813 1.515 0 2.813 1.298 2.813 2.813 0 1.515-1.298 2.813-2.813 2.813",
    "data-name": "Path 280298"
  }))));
};
export default SvgAddressLogo;